import { render } from "./header_1.vue?vue&type=template&id=db7aaf38"
import script from "./header_1.vue?vue&type=script&lang=js"
export * from "./header_1.vue?vue&type=script&lang=js"

import "./header_1.vue?vue&type=style&index=0&id=db7aaf38&lang=css"
script.render = render

export default script